export class SecureFileTransferCredentials {
  password: string = null;
  port: string = null;
  server: string = null;
  userName: string = null;
}
